import React from "react"
import type { PropsWithChildren } from "react"
import type {
  MultipleProductCard,
  SingularProductCard,
  VariantType,
} from "types"
import { ProductCardContext } from "../../hooks/useProductCard"
import { productCardStyle } from "./ProductCard.css"
import type { ProductCardDataType } from "./types"

export interface ProductCardProps extends PropsWithChildren {
  product: ProductCardDataType
  productCard?: SingularProductCard | MultipleProductCard
  addToBasket: () => void
  setIsShadeSelectorOpen?: React.Dispatch<React.SetStateAction<boolean>>
  confirmationVariant: VariantType | null
  setConfirmationVariant?: React.Dispatch<
    React.SetStateAction<VariantType | null>
  >
  setConfirmation?: React.Dispatch<React.SetStateAction<boolean>>
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

export const ProductCard: React.FC<ProductCardProps> = ({
  children,
  product,
  productCard,
  addToBasket,
  setIsShadeSelectorOpen,
  setConfirmationVariant,
  confirmationVariant,
  setConfirmation,
  onClick,
}: ProductCardProps) => {
  return (
    <ProductCardContext.Provider
      data-testid="product-card"
      value={{
        productCardData: product,
        productCard,
        addToBasket,
        setIsShadeSelectorOpen,
        setConfirmationVariant,
        confirmationVariant,
        setConfirmation,
      }}
    >
      <a
        href={product.href}
        title={product.productName}
        className={productCardStyle}
        onClick={(e) => onClick?.(e)}
      >
        {children}
      </a>
    </ProductCardContext.Provider>
  )
}
